export const PlaceholderCardsSubTitle = [
  {
    text: "In the example below, we take a typical card component and recreate it with placeholders applied to create a ",
    code: "loading card ",
  },
  {
    text: "and create placeholders with the ",
    code: "placeholder ",
  },
  {
    text: "class.",
  },
];

export const WidthAndSizingSubTitle = [
  {
    code: "placeholder ",
  },
  {
    text: "class + grid column (e.g., col-6) sets width. Works as text replacement or modifier class.Create flexible placeholders: ",
    code: "placeholder + grid for width",
  },
  {
    text: ". Replace text or modify components.",
  },
];

export const AnimationSubTitle = [
  {
    text: "Animate placeholders with ",
    code: "placeholder-glow ",
  },
  {
    text: "or ",
    code: "placeholder-wave ",
  },
  {
    text: "to better convey the perception of something being actively loaded.",
  },
];

export const CustomAnimationPlaceholderSubTitle = [
  {
    text: "With the ",
    code: "wave-left-lines ",
  },
  {
    text: "custom animation, placeholders may be used into your unique design.",
  },
];

export const ColorsSubTitle = [
  {
    text: "By default, the ",
    code: "placeholder ",
  },
  {
    text: "uses ",
    code: "currentcolor",
  },
  {
    text: ". This can be overridden with a custom color or utility class.",
  },
];

export const ColorsData = ["primary", "secondary", "success", "danger", "warning", "info", "light", "dark"];
